import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import LoadingSpinner from "../../LoadingSpinner";
import AddConfigurationModal from "./AddConfigurationModal";
import EditConfigurationModal from "./EditConfigurationModal";
import DeleteConfigurationModal from "./DeleteConfigurationModal";
import {
  useGetAiConfigurationQuery,
  useGetVectorConfigurationQuery,
  useGetYoutubeConfigurationQuery
} from "../../../Services/instagram/Instagram";

const Configuration = () => {
  const [editModal, setEditModal] = useState(false);
  const [modalOpenStatus, setModalOpenStatus] = useState("configure");
  const [isDeleteButtonClicked, setIsDeleteButtonClicked] = useState(false);
  const [selectedYouTubeId, setSelectedYouTubeId] = useState<any>("");

  // Fetch configurations
  const { data: youtubeData, isLoading: isYoutubeLoading, refetch: refetchYoutubeData } = useGetYoutubeConfigurationQuery({});
  const { data: vectorData, isLoading: isVectorLoading, refetch: refetchVectorData } = useGetVectorConfigurationQuery({});
  const { data: aiData, isLoading: isAiLoading, refetch: refetchAiData } = useGetAiConfigurationQuery({});

  const [combinedConfigs, setCombinedConfigs] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Combine data when all API calls are complete
  useEffect(() => {

    if (youtubeData && vectorData && aiData) {
      // Extract results array from each response, default to empty array if not available
      const youtubeResults = youtubeData.results || [];

      const vectorResults = vectorData.results || [];
      const aiResults = aiData.results || [];
     

      const combined = youtubeResults.map((youtube: any) => {
        return {
          ...youtube,
          vector_config: vectorResults[0] || {},  // attach first vector result
          ai_config: aiResults[0] || {}           // attach first AI result
        };
      });

      setCombinedConfigs(combined);
      setIsLoading(false);
    }else{
      setIsLoading(false);
    }
  }, [youtubeData, vectorData, aiData]);

  console.log(combinedConfigs)

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%", // Default to full width
      maxWidth: "850px", // Max width for larger screens
      height: "60%",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };


  const deleteCustomModalStyles: ReactModal.Styles = {
    content: {
      top: "50%",
      left: "50%",
      width: "30%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };


  const closeEditModal = () => setEditModal(false);

  const openEditModal = (modalStatus: string, item: any) => {
    setModalOpenStatus(modalStatus);
    setEditModal(true);
  };

  const closeDeleteModal = () => setIsDeleteButtonClicked(false);

  const openDeleteModal = (id: any) => {
    setSelectedYouTubeId(id);
    setIsDeleteButtonClicked(true);
  };

  // Show loading spinner if any of the API calls are loading
  if (isYoutubeLoading || isVectorLoading || isAiLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div style={{ marginLeft: "3%" }}>
      <div className="row">
        <div className="col-10">
          <span className="input-group-text mt-2" id="basic-addon1">
            YouTube configuration
          </span>
        </div>

        {combinedConfigs?.length === 0 && (
          <div className="col text-end">
            <button
              type="button"
              className="btn btn-primary mt-2"
              onClick={() => openEditModal("configure", null)}
            >
              {combinedConfigs?.length > 0 ? 'Add new configuration' : 'New configuration'}
            </button>
          </div>
        )}
      </div>

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {combinedConfigs?.length > 0 && (
            <div
              className="row mx-0 mb-2 rounded-3 py-4"
              style={{ maxHeight: "60vh" }}
            >
              <div className="row g-4">
                {combinedConfigs.map((config, index) => (
                  <div key={config.id} className="col-12">
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <h5 className="mb-0">
                          <i className="bi bi-youtube me-2 text-danger"></i>
                          YouTube configuration #{index + 1}
                        </h5>
                        <div>
                          <button
                            className="btn btn-sm btn-icon btn-light-primary me-2"
                            onClick={() => openEditModal("edit", config)}
                            title="Edit"
                          >
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-icon btn-light-danger"
                            onClick={() => openDeleteModal(config.id)}
                            title="Delete"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row g-4">
                          <div className="col-md-6">
                            <div className="d-flex align-items-center mb-3">
                              <span className="fw-bold me-2">Channel ID:</span>
                              <span className="text-muted">{config.channel_id || 'N/A'}</span>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                              <span className="fw-bold me-2">Client ID:</span>
                              <span className="text-muted text-truncate" style={{ maxWidth: '300px' }} title={config.client_id}>
                                {config.client_id || 'N/A'}
                              </span>
                            </div>
                            <div className="d-flex align-items-center">
                              <span className="fw-bold me-2">Token expiry:</span>
                              <span className="text-muted">
                                {config.token_expiry ? new Date(config.token_expiry).toLocaleString() : 'N/A'}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="d-flex align-items-center mb-3">
                              <span className="fw-bold me-2">Client secret:</span>
                              <span className="text-muted text-truncate" style={{ maxWidth: '300px' }} title={config.client_secret}>
                                {config.client_secret ? '••••••••••••••••••••' : 'N/A'}
                              </span>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                              <span className="fw-bold me-2">Auto ticket:</span>
                              <span className={`badge bg-${config.auto_ticket ? 'success' : 'secondary'}`}>
                                {config.auto_ticket ? 'Enabled' : 'Disabled'}
                              </span>
                            </div>
                            {config.auto_ticket && config.ticket_msg && (
                              <div className="d-flex align-items-center">
                                <span className="fw-bold me-2">Ticket message:</span>
                                <span className="text-muted">{config.ticket_msg}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer bg-light d-flex justify-content-between align-items-center">
                        <small className="text-muted">
                          Last updated: {new Date(config.updated).toLocaleString()}
                        </small>
                        <div>
                          <span className={`badge bg-${config.token_expiry && new Date(config.token_expiry) > new Date() ? 'success' : 'danger'} me-2`}>
                            {config.token_expiry && new Date(config.token_expiry) > new Date() ? 'Token active' : 'Token expired'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>


            </div>
          )}
        </>
      )}

      {/* Edit Modal */}
      <ReactModal
        isOpen={editModal}
        onRequestClose={closeEditModal}
        style={customModalStyles}
      >
        {modalOpenStatus === "configure" ? (
          <AddConfigurationModal 
            closeModal={closeEditModal}
            refetchYoutubeData={refetchYoutubeData}
            refetchVectorData={refetchVectorData}
            refetchAiData={refetchAiData}
          />
        ) : (
          <EditConfigurationModal
            closeModal={closeEditModal}
            configurationData={combinedConfigs[0]}
            refetchYoutubeData={refetchYoutubeData}
            refetchVectorData={refetchVectorData}
            refetchAiData={refetchAiData}
          />
        )}
      </ReactModal>

      {/* Delete Modal */}
      <ReactModal
        isOpen={isDeleteButtonClicked}
        onRequestClose={closeDeleteModal}
        style={deleteCustomModalStyles}
      >
        <DeleteConfigurationModal
          closeModal={closeDeleteModal}
          fieldsData={combinedConfigs[0]}
          refetchYoutubeData={refetchYoutubeData}
          refetchVectorData={refetchVectorData}
          refetchAiData={refetchAiData}
        />
      </ReactModal>
    </div>
  );
};

export default Configuration;
